import React, { useContext, useState } from 'react'
import { HeaderNotice } from '@/network/graphql.g'

const HeaderNoticeContext = React.createContext<HeaderNotice>(null)
const HeaderNoticeDispatchContext =
  React.createContext<HeaderNoticeDispatchType>(null)

type HeaderNoticeDispatchType = {
  setHeaderNotice: (headerNotice: HeaderNotice) => void
}

export const useHeaderNotice = (): HeaderNotice =>
  useContext(HeaderNoticeContext)

export const useHeaderNoticeDispatch = (): HeaderNoticeDispatchType =>
  useContext(HeaderNoticeDispatchContext)

const HeaderNoticeProvider: React.FC = ({ children }) => {
  const [headerNotice, setHeaderNoticeInternal] = useState<HeaderNotice>(null)

  const setHeaderNotice = (value: HeaderNotice): void => {
    setHeaderNoticeInternal(value)
  }

  return (
    <HeaderNoticeDispatchContext.Provider value={{ setHeaderNotice }}>
      <HeaderNoticeContext.Provider value={headerNotice}>
        {children}
      </HeaderNoticeContext.Provider>
    </HeaderNoticeDispatchContext.Provider>
  )
}

export default HeaderNoticeProvider
